<template>
  <div class="index">
    <!-- 搜索框 -->
    <div class="search">
      <div class="w1200">
        <el-form  class="searchbox" ref="fData" :model="fData">
          <el-row style="border:1px solid #1E9FFF">
            <el-col :span="4">
              <el-select class="fuwutype" v-model="fData.fuwutype" placeholder="请选择服务">
                <el-option v-for="x in fuwuList" :key="x.name" :label="x.name" :value="x.value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="18">
              <el-input v-model="fData.keywords" placeholder="请输入内容" clearable></el-input>
            </el-col>
            <el-col :span="2">
              <el-button class="searchbutton" type="primary" icon="el-icon-search" @click="searchHandler"></el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="welcome">现有 <i class="red">{{informationnum}}</i> 在线信息，祝您成功， {{datestr}}</div>
      </div>
    </div>
    <!-- 根据路由更换内容 -->
    <div class="fuwubox">
      <!-- 筛选功能 -->
      <div class="w1200 selectfuwu filter">
        <!-- 选择服务模块 -->
        <div class="flex filter_title">
          <div class="titlebox">选择服务</div>
          <div class="list">
            <span v-for="(x,i) of fuwuList" :key="i" :class="{'active':navAc===x.value}" @click="navChange(x.value)">{{x.name}}</span>
            <!-- <span :class="{'active':navAc==='quickqiuzhi'}" @click="navChange('quickqiuzhi')">快速求职</span> -->
          </div>
        </div>
        <!-- 模块对应的筛选条件 -->
        <div class="filter_box" v-if="navAc!=='quickqiuzhi'">
          <div class="item flex" v-for="(x, i) in filterList" :key="i">
            <div class="item-title titlebox">{{x.label}}</div>
            <div class="item-options list listbox" v-if="x.type==='radio'">
              <span
                v-for="(x2, i2) in x.items" :key="i2"
                class="item-options-item" :class="{'active':i2===x.activeindex}"
                @click="filterClick(i,i2)">{{x2}}</span>
            </div>
            <div class="item-options" style="margin-left:8px" v-if="x.type==='select'">
              <el-select v-model="fData.titleType" @change="getData()" placeholder="请选择">
                <el-option v-for="(x,i) in x.items" :key="i" :label="x" :value="x">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 渲染数据 -->
    <div class="flex showData w1200" v-if="navAc!=='quickqiuzhi'">
      <!-- 左 -->
      <div class="left">
        <falvzixun ref="falvzixun" v-if="navAc==='lvshi'&&lvshi_list[0].activeindex===0" :tableData="zixun_data" @sonGetParentPaging_data="getDataSize"></falvzixun>
        <fuwuleft v-else :tableData="tableData" :navAc="navAc" :showDataList="showDataList" ></fuwuleft>
        <paging :pagesData="paging_data" @set_page_number="pageChange"></paging>
      </div>
      <!-- 右 -->
      <div class="right">
        <!-- <div class="anjianweituo" v-if="navAc=='lvshi'&& lvshi_list[0].activeindex===0" style="margin-bottom:15px">
          <a href="/ajwt.html"><img src="@/assets/anjianweituo.jpg" alt=""></a>
        </div> -->
        <div class="noCase">
          <div class="title">排行榜</div>
          <div class="listbox" v-if="navAc!=='zhaopin'&&navAc!=='qiuzhi'&&navAc!=='lvshi'">
            <ul class="list" :class="{'animate':animate}" ref="swiper" @mouseover="gunPause" @mouseout="gunStart">
              <li v-for="(x,i) in scrollList" :key="i" @click="scrollClick(i,navAc)">
                <span v-if="navAc==='jiaoyou'">{{x.u_nickName}}</span>
                <span v-else>{{x.name}}</span>
              </li>
            </ul>
          </div>
          <div class="listboxa" v-if="navAc==='zhaopin'">
            <ul class="list" :class="{'animate':animate}" ref="swipera" @mouseover="gunPause" @mouseout="gunStart">
              <li v-for="(x,i) in scrollList" :key="i" @click="scrollClick(i,navAc)">
                <div class="imgbox">
                  <img :src="x.o_homeUrl|toimg" />
                </div>
                <p class="comname">{{x.o_name}}</p>
                <div class="info">
                  <span><p class="number">0</p><p class="text">面试评价</p></span>
                  <span><p class="number">0</p><p class="text">在招职位</p></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="listboxb" v-if="navAc==='qiuzhi'">
            <ul class="list" :class="{'animate':animate}" ref="swiperb" @mouseover="gunPause" @mouseout="gunStart">
              <li v-for="(x,i) in scrollList" :key="i" @click="scrollClick(i,navAc)">
                <div class="imgbox">
                  <img :src="x.u_logo|toimg" />
                </div>
                <p class="peoplename">{{x.u_nickName}}</p>
                <p class="workname">{{x.u_expectJob}}</p>
                <p class="money">5000</p>
              </li>
            </ul>
          </div>
          <div class="listbox" v-if="navAc=='lvshi'&&lvshi_list[0].activeindex===0">
            <ul class="list" :class="{'animate':animate}" ref="swiperc" @mouseover="gunPause" @mouseout="gunStart">
              <li v-for="(x,i) in scrollList" :key="i" @click="scrollClick(i,navAc)">{{x.title}}</li>
            </ul>
          </div>
          <div class="lvshibox" v-if="navAc=='lvshi'&&lvshi_list[0].activeindex!==0">
            <ul class="list" :class="{'animate':animate}" ref="swiperd" @mouseover="gunPause" @mouseout="gunStart">
              <li v-for="(x,i) in scrollList" :key="i" @click="scrollClick(i,navAc)">
                <div class="imgbox">
                  <img :src="x.imgUrl|toimg" />
                </div>
                <p class="name">{{x.name}}律师</p>
                <p class="pinjia">综合评价：{{x.score}}</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- <advertisement v-if="navAc!=='lvshi'" :imgwidth="advertisementImgWidth" :imgheight="advertisementImgHeight"></advertisement> -->
      </div>
    </div>

    <div class="flex showData w1200" v-else>
      <quickqiuzhi />
    </div>
    
  </div>
</template>

<script>
import { fuwuList } from '@/publicData/fuwuList'
import { fuwuData } from '@/publicData/fuwuData'
import fuwuleft from '@/views/showpage/components/fuwuLeft'
import falvzixun from '@/views/showpage/components/falvzixun'
import quickqiuzhi from '@/views/showpage/components/quickqiuzhi'
import advertisement from '@/views/showpage/components/advertisement'
export default {
  components: { fuwuleft, falvzixun, quickqiuzhi, advertisement },
  data() {
    return {
      fuwuList: fuwuList,
      datestr: '', // 搜索框下面的时间
      fData:{
        fuwutype: 'zhaopin',
        keywords: '',
      },
      navAc: 'zhaopin', // 默认服务为教育
      rData: {}, // 查询条件对象
      zixun_data: [],

      
      //分页数据
      zhaopin_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      zixun_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      qiuzhi_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      lvshi_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      jiaoyu_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      peixun_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      rongzi_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      touzi_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      zhaoshang_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      jiameng_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      zufang_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      shoufang_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      qiche_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      jiaoyou_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      gouwu_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      meishi_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      lvyou_paging_data: { currentPage: 1, pageSize: 40, total: 0 },
      jiankang_paging_data: { currentPage: 1, pageSize: 40, total: 0 },

      isStart: true, // 控制数据列表右边的滚动动画是否停止
      timer: '', // 动画的计时器
      timer2: '', // 动画的延时器
      animate: false, // 动画类名
      scrollList: [], // 拿到查询到的数据，做右侧滚动效果，由于会删除首元素添加到末尾元素，会改变原数组，所以深拷贝拿到的数据，不会对显示数据干扰

      advertisementImgWidth: '210px', // 排行榜下面的广告图片的宽度
      advertisementImgHeight: '108px', // 排行榜下面的广告图片的高度

      isGetScrollData: false, // 从人事人才跳转过来时，同样需要请求滚动条

      zhaopin_data: [],
      qiuzhi_data: [],
      lvshi_data: [],
      jiaoyu_data: [],
      peixun_data: [],
      rongzi_data: [],
      touzi_data: [],
      zhaoshang_data: [],
      jiameng_data: [],
      zufang_data: [],
      shoufang_data: [],
      qiche_data: [],
      jiaoyou_data: [],
      gouwu_data: [],
      meishi_data: [],
      lvyou_data: [],
      jiankang_data: [],

      // 动态渲染筛选条件
      zhaopin_list: [ // 招聘
        {label:'职位薪资',type:'radio',items:this.$fuwuData.isgongzishuiping,activeindex:0},
        {label:'职位类别',type:'radio',items:this.$fuwuData.zhiweitype,activeindex:0},
        {label:'行业筛选',type:'select',items:this.$fuwuData.suoshuhangye3g,activeindex:0}
      ],
      qiuzhi_list: [ // 求职
        {label:'类别',type:'radio',items: this.$fuwuData.zhiweileibie,activeindex:0},
        {label:'性别',type:'radio',items: this.$fuwuData.isSex,activeindex:0},
        {label:'年龄',type:'radio',items: this.$fuwuData.age,activeindex:0},
        {label:'学历',type:'radio',items: this.$fuwuData.education,activeindex:0},
        {label:'经验',type:'radio',items: this.$fuwuData.express,activeindex:0},
      ],
      lvshi_list: [ // 律师
        {label:'案件类型',type:'radio',items:this.$fuwuData.laytype1,activeindex:0},
      ],
      jiaoyu_list: [ // 教育
        {label:'性质',type:'radio',items:this.$fuwuData.hireProperty,activeindex:0},
        {label:'班次',type:'radio',items:this.$fuwuData.banci,activeindex:0},
        {label:'学历',type:'radio',items:this.$fuwuData.education,activeindex:0},
      ],
      peixun_list: [ // 培训
        {label:'性质',type:'radio',items:this.$fuwuData.hireProperty,activeindex:0},
        {label:'班次',type:'radio',items:this.$fuwuData.banci,activeindex:0},
      ],
      rongzi_list: [ // 融资
        {label:'状态',type:'radio',items:this.$fuwuData.xiangmustatus,activeindex:0},
        {label:'行业',type:'select',items:this.$fuwuData.suoshuhangye3g},
      ],
      touzi_list: [ // 投资
        {label:'方式',type:'radio',items:this.$fuwuData.touzitype,activeindex:0},
        {label:'行业',type:'select',items:this.$fuwuData.suoshuhangye3g},
      ],
      zhaoshang_list: [ // 招商
        {label:'状态',type:'radio',items:this.$fuwuData.xiangmustatus,activeindex:0},
        {label:'行业',type:'select',items:this.$fuwuData.suoshuhangye3g},
      ],
      jiameng_list: [ // 加盟
        {label:'状态',type:'radio',items:this.$fuwuData.xiangmustatus,activeindex:0},
        {label:'行业',type:'select',items:this.$fuwuData.suoshuhangye3g},
      ],
      zufang_list: [ // 租房
        {label:'类型',type:'radio',items:this.$fuwuData.housetype,activeindex:0},
        {label:'装修',type:'radio',items:this.$fuwuData.housezhuangxiu,activeindex:0},
      ],
      shoufang_list: [ // 售房
        {label:'类型',type:'radio',items:this.$fuwuData.housetype,activeindex:0},
        {label:'装修',type:'radio',items:this.$fuwuData.housezhuangxiu,activeindex:0},
      ],
      qiche_list: [ // 汽车
        {label:'类型',type:'radio',items:this.$fuwuData.cartype,activeindex:0},
      ],
      jiaoyou_list: [ // 交友
        {label:'性别',type:'radio',items:this.$fuwuData.isSex,activeindex:0},
        {label:'学历',type:'radio',items:this.$fuwuData.friendeducation,activeindex:0},
      ],
      gouwu_list: [], // 电商   无筛选条件
      meishi_list: [ // 美食
        {label:'类别',type:'radio',items:this.$fuwuData.foodtype,activeindex:0},
        {label:'方式',type:'radio',items:this.$fuwuData.getfoodtype,activeindex:0},
      ],
      lvyou_list: [], // 旅游
      jiankang_list: [], // 健康

      // 因为每项服务  数据展示的数据都不一样，所以遍历每个不同的列表，来展示不同的属性
      zhaopin_list_info: [ // 招聘
        {title:'学历:',shuxing:'education'},
        {title:'工作经验:',shuxing:'workExperience'},
        {title:'人数:',shuxing:'needPersons'},
        {title:'地址:',shuxing:'address'},
      ],
      qiuzhi_list_info: [ // 求职
        {title:'性质:',shuxing:'u_jobType'},
        {title:'性别:',shuxing:'u_sex'},
        {title:'年龄:',shuxing:'age'},
        {title:'学历:',shuxing:'u_education'},
        {title:'经验:',shuxing:'u_workYear'},
      ],
      lvshi_list_info: [ // 律师
        {title:'执业证号：',shuxing:'certNo'},
        {title:'业务专长：',shuxing:'l_professional'},
        {title:'办公地址：',shuxing:'l_wordAddress'},
      ],
      jiaoyu_list_info: [ // 教育
        {title:'毕业学历：',shuxing:'educationBackGround'},
        {title:'招生性质：',shuxing:'hireProperty'},
        {title:'地址：',shuxing:'address'},
      ],
      peixun_list_info: [ // 培训
        {title:'培训班次：',shuxing:'trainingShifts'},
        {title:'招生性质：',shuxing:'traingingProperty'},
        {title:'地址：',shuxing:'address'},
      ],
      rongzi_list_info: [ // 融资
        {title:'项目状态：',shuxing:'status'},
        {title:'融资额度(万元)：',shuxing:'cash'},
        {title:'投资地址：',shuxing:'address'},
      ],
      touzi_list_info: [ // 投资
        {title:'项目情况：',shuxing:'status'},
        {title:'投资额度(万元)：',shuxing:'cash'},
        {title:'所属行业：',shuxing:'belongToDomain'},
        {title:'地址：',shuxing:'address'},
      ],
      zhaoshang_list_info: [ // 招商
        {title:'项目情况：',shuxing:'status'},
        {title:'所属行业：',shuxing:'belongToDomain'},
        {title:'地址：',shuxing:'address'},
      ],
      jiameng_list_info: [ // 加盟
        {title:'项目情况：',shuxing:'status'},
        {title:'所属行业：',shuxing:'belongToDomain'},
        {title:'加盟地点：',shuxing:'address'},
      ],
      zufang_list_info: [ // 租房
        {title:'是否合租：',shuxing:'isTogether'},
        {title:'楼层：',shuxing:'layer'},
        {title:'房型：',shuxing:'houseType'},
        {title:'装修方式：',shuxing:'renovation'},
        {title:'地址：',shuxing:'address'},
      ],
      shoufang_list_info: [ // 售房
        {title:'楼层：',shuxing:'layer'},
        {title:'房型：',shuxing:'houseType'},
        {title:'装修方式：',shuxing:'renovation'},
        {title:'地址：',shuxing:'address'},
      ],
      qiche_list_info: [ // 汽车
        {title:'售价(元)：',shuxing:'cash'},
        {title:'车龄：',shuxing:'driverAge'},
        {title:'汽车车型：',shuxing:'carType'},
        {title:'里程：',shuxing:'driverDistance'},
      ],
      jiaoyou_list_info: [ // 交友
        {title:'身高：',shuxing:'u_height'},
        {title:'年龄：',shuxing:'f_age'},
        {title:'学历：',shuxing:'u_education'},
        {title:'工作地点：',shuxing:'f_wordAddress'},
      ],
      gouwu_list_info: [ // 电商
        {title:'单价(元)：',shuxing:'price'},
        {title:'地点：',shuxing:'address'},
      ],
      meishi_list_info: [ // 美食
        {title:'消费标准(元/人)：',shuxing:'costStandard'},
        {title:'美食类别：',shuxing:'foodType'},
        {title:'美食地点：',shuxing:'address'},
      ],
      lvyou_list_info: [ // 旅游
        {title:'消费标准(元/人)：',shuxing:'costStandard'},
        {title:'行程天数(天)：',shuxing:'tourDays'},
        {title:'地点：',shuxing:'address'},
      ],
      jiankang_list_info: [ // 健康
        {title:'医疗方式：',shuxing:'medicalType'},
        {title:'医疗科别：',shuxing:'medicalCatalog'},
        {title:'地点：',shuxing:'address'},
      ],
    }
  },
  computed: {
    filterList() {
      this.rData = {} // 改变服务类型就重置一次查询条件对象
      return this[this.navAc + '_list']
    },
    showDataList() { return this[this.navAc + '_list_info'] },
    tableData() { return this[this.navAc + '_data'] },
    
    paging_data() { return this[this.navAc + '_paging_data'] },
    informationnum() { return this.paging_data.total },
  },
  watch: {
    pageAreaId_x(val) {
      this.getData()
    }
  },
  methods: {
    // ———————————————————————————— 右边的动画效果 ————————————————————————————
    gundong(str) {
      let swiper = this.$refs[str]
      if (swiper) {
        this.animate = !this.animate
        if (this.navAc== 'zhaopin') {
          swiper.style.top = '-201px'
        } else if (this.navAc === 'qiuzhi') {
          swiper.style.top = '-211px'
        } else if (this.navAc === 'lvshi' && this.lvshi_list[0].activeindex!=0) {
          swiper.style.top = '-160px'
        } else {
          swiper.style.top = '-30px'
        }
        this.timer2 = setTimeout(() => {
          this.scrollList.push(this.scrollList[0])
          this.scrollList.shift()
          swiper.style.top = '0px'
          this.animate = !this.animate // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
          clearTimeout(this.timer2)
        }, 500)
      }
    },
    gunStart() {
      let str,timenum
      this.$route.query.type ? this.navAc = this.$route.query.type : ''
      switch(this.navAc) {
        case 'zhaopin':
          str = 'swipera'
          timenum = 3000
          break
        case 'qiuzhi':
          str = 'swiperb'
          timenum = 3000
          break
        case 'lvshi':
          if (this.lvshi_list[0].activeindex==0) {
            str = 'swiperc'
            timenum = 2000
          } else {
            str = 'swiperd'
            timenum = 3000
          }
          break
        default:
          str = 'swiper'
          timenum = 2000
      }
      this.isStart ? this.timer = setInterval(() => { this.gundong(str) }, timenum) :''
    },
    gunPause() {
      clearInterval(this.timer)
    },
    // ———————————————————————————— 右边的动画效果 ————————————————————————————

    navChange(val) {
      this.navAc = val
      let url = '/fuwu?areaId='+this.pageAreaId_x+'&type='+this.navAc+'&page='+this.paging_data.currentPage
      
      if (val === 'quickqiuzhi') {

      } else if (this.$route.fullPath !== url) {
        this.fData.fuwutype = val

        this.rData = {}
        delete this.fData.titleType // 筛选条件中有下拉框的  删除下拉框的值，部分有下拉框
        // 将筛选条件的高亮效果移回  ‘不限’
        this[this.navAc + '_list'].forEach(x =>{
          if (x.activeindex) { x.activeindex = 0 }
        })

        this.$router.replace(url)
        this.gunPause()
        this.gunStart()
        
        this.getData()
      }
    },
    // 点击右边的滚动中的数据
    scrollClick(index,navAc) {
      console.log('你点的这条数据',this.scrollList[index])
      let data = this.scrollList[index]
      // console.log('点了之后',data)
      data.navAc = navAc // 判断点击的信息属于哪个服务
      if (this.navAc === 'zhaopin') {
        this.$router.push('detailList?type=companyhome&oname='+data.o_name)
      } else if (this.navAc === 'lvshi') {
        this.lvshi_list[0].activeindex != 0
          ? this.$router.push('layerDetail?type='+this.navAc+'&id='+data.id+'&key=home')
          : console.log('跳转咨询详情')
      } else {
        if (data.o_name) {
          this.$router.push('/detail?type='+this.navAc+'&oname='+data.o_name+'&id='+data.id)
        } else {
          this.$router.push('/detail?type='+this.navAc+'&oname=undefined'+'&id='+data.id)
        }
      }
      this.gunPause()
    },
    // 点击筛选条件，给高亮显示
    async filterClick(i, i2) {
      this[this.navAc + '_list'][i].activeindex = i2

      // this.searchHandler()
      delete this.rData.name
      delete this.rData.u_nickName
      delete this.rData.jobName
      this.paging_data.currentPage = 1
      this.getData(i, i2)

      console.log(`%cthis.scrollList:`, 'color: #f00;', this.scrollList)
      if (this.scrollList.length > 0) {
        let sendrequest = this.scrollList[0].hasOwnProperty('layType') //判断右边数据是否含有律师信息特有的属性layType，也就是判断当前右边滚的信息是否是律师
        if (this.navAc === 'lvshi') {
          if (i2 === 0) {//右边滚动栏展示法律咨询信息
            await this.$api.util_search('zixun', {pageNumber:1}).then(res => {
              if (res.data.status === 0) {
                this.scrollList = JSON.parse(res.data.data)
              } else { this._status(res.data) }
            })
          } else {//右边滚动栏展示律师信息
            if (!sendrequest) {
              await this.$api.util_search('lvshi', {pageNumber:1}).then(res => {
                if (res.data.status === 0) {
                  this.scrollList = JSON.parse(res.data.data)
                } else { this._status(res.data) }
              })
            }
          }
          this.gunPause()
          this.gunStart()
        }
      }
    },

    
    // 点击展示的数据，传入索引拿到数据，进入详情路由
    clickData(index, navAc) {
      this.gunPause()
      let data = this.tableData[index]
      console.log(`%c点中的数据:`, 'color: #00f;', data)
      data.navAc = navAc // 判断点击的信息属于哪个服务
      // this.$store.commit('goDetailPage', data);
      if (this.navAc == 'zhaopin') {
        this.$router.push(`recruitDetail?type=${this.navAc}&id=${data.id}`)
      } else if (this.navAc == 'lvshi') {
        this.$router.push(`/layerDetail?type=lvshi&id=${data.id}&key=home`)
      } else {
        if (data.o_name) {
          this.$router.push(`/detail?type=${this.navAc}&oname=${data.o_name}&id=${data.id}`)
        } else {
          this.$router.push(`/detail?type=${this.navAc}&oname=undefined&id=${data.id}`)
        }
      }
    },


    // 获取页码
    pageChange(pageNumber) {
      if (this.$refs.falvzixun) {
        this.$refs.falvzixun.isShowList = true
        this.$refs.falvzixun.detailData = {}
      }
      this.paging_data.currentPage = pageNumber
      this.$router.replace('/fuwu?areaId='+this.pageAreaId_x+'&type='+this.navAc+'&page='+pageNumber)

      // 实现滚动效果
      const timeTop = setInterval(() => {
        let top = document.documentElement.scrollTop
        document.documentElement.scrollTop -= 200
        if (top <= 400) {
          this.getData()
          clearInterval(timeTop)
        }
      }, 10)
    },
    // 获取日期和星期
    getDateWeek() {
      const week = ['天','一','二','三','四','五','六']
      let date = new Date()
      let datestr = date.getFullYear()+'年'+(date.getMonth()+1)+'月'+date.getDate()+'日'+' 星期'+week[date.getDay()]
      this.datestr = datestr
    },

    // 点击搜索框查询数据
    searchHandler() {
      this.navAc = this.fData.fuwutype

      const map1 = [
        // 'zhaopin',
        // 'qiuzhi',
        // 'lvshi',
        'jiaoyu',
        'peixun',
        'rongzi',
        'touzi',
        'zhaoshang',
        'jiameng',
        'zufang',
        'shoufang',
        'qiche',
        // 'jiaoyou',
        'gouwu',
        'meishi',
        'lvyou',
        'jiankang',
      ]
      const kw = this.fData.keywords

      delete this.rData.name
      delete this.rData.u_nickName
      delete this.rData.jobName

      if (kw) {
        if (map1.includes(this.navAc)) {
          this.rData.name = kw
        } else if (this.navAc === 'zhaopin') {
          this.rData.jobName = kw
        } else if (this.navAc === 'lvshi') {
          this.lvshi_list[0].activeindex = 1
          this.rData.name = kw
        } else if (this.navAc === 'qiuzhi' || this.navAc === 'jiaoyou') {
          this.rData.u_nickName = kw
        }
      }

      let { areaId, type, page, key } = this.$route.query
      let url = '/fuwu?areaId='+areaId+'&type='+this.navAc+'&page='+page
      if (key) {
        url += '&key='+encodeURI(key)
      }
      console.log(this.$route.fullPath, url, this.$route.fullPath !== url)
      if (this.$route.fullPath !== url) {
        this.$router.replace(url)
      // } else if (type === this.navAc) {
      } else {
        this.getData()
      }
    },
    //获取条件查询数据，需要传的条件对象======拿到的数据是 该服务下 经过条件查询的，但是如果让i2一直为0并且下拉框的值为'不限'，就可以得到该服务下所有的数据信息
    async getData(i, i2) {
      // let i2 = this[this.navAc + '_list'][i].activeindex

      this.rData.areaId = this.pageAreaId_x || this.$route.query.areaId

      let navAcHere = this.navAc

      switch (this.navAc) {
        case 'lvshi':
          if (this.lvshi_list[0].activeindex === 0) {
            navAcHere = 'zixun'
            delete this.rData.layType
          } else {//律师
            console.log(`%ctype:`, 'color: #f00;', this.$fuwuData.laytype1[i2])
            if (this.$fuwuData.laytype1[i2] === '不限') { delete this.rData.layType }
            else if (this.$fuwuData.laytype1[i2]) { this.rData.layType = [this.$fuwuData.laytype1[i2]] }
            else { delete this.rData.layType }
          }
          break;
        case 'zhaopin':
          if (i === 0) {//第一行条件  薪资
            this.rData.salary = this.$fuwuData.isgongzishuiping[i2]
            if (i2 === 0) { delete this.rData.salary }
          } else if (i === 1) {//第二行条件 类别
            this.rData.jobType = this.$fuwuData.zhiweitype[i2]
            if (i2 === 0) { delete this.rData.jobType }
          }
          //当下拉框选择‘不限’或者不选择时  就删除 ‘行业’ 属性  ,否则就赋值
          (!this.fData.titleType || this.fData.titleType=='不限')
            ? delete this.rData.belongToDomain
            : this.rData.belongToDomain = this.fData.titleType
          break;
        case 'qiuzhi':
          if (i === 0) {//第一行条件  职业类别
            this.rData.u_jobType = this.$fuwuData.zhiweileibie[i2]
            if (i2 === 0) { delete this.rData.u_jobType }
          } else if (i === 1) {//第二行条件 性别
            this.rData.u_sex = this.$fuwuData.isSex[i2]
            if (i2 === 0) { delete this.rData.u_sex }
          } else if (i === 2) {//第三行条件
            // this.rData.age = this.$fuwuData.education[i2]
            // if (i2 === 0) {
            //   delete this.rData.age
            // }
          } else if (i === 3) {//第四行条件  学历
            this.rData.u_education = this.$fuwuData.education[i2]
            if (i2 === 0) { delete this.rData.u_education }
          } else if (i === 4 ) {//第五行条件
            this.rData.u_workYear = this.$fuwuData.express[i2]
            if (i2 === 0) { delete this.rData.u_workYear }
          }
          this.rData.u_startGetJob = true
          break;
        case 'jiaoyu':
          if (i === 0) {//第一行条件
            this.rData.hireProperty = this.$fuwuData.hireProperty[i2]
            if (i2 === 0) { delete this.rData.hireProperty }
          } else if (i === 1) {//第二行条件
            this.rData.hireClass = this.$fuwuData.banci[i2]
            if (i2 === 0) { delete this.rData.hireClass }
          } else if (i === 2) {//第三行条件
            this.rData.educationBackGround = this.$fuwuData.education[i2]
            if (i2 === 0) { delete this.rData.educationBackGround }
          }
          break;
        case 'peixun':
          if (i === 0) {//第一行条件
            this.rData.traingingProperty = this.$fuwuData.hireProperty[i2]
            if (i2 === 0) { delete this.rData.traingingProperty }
          } else if (i === 1) {//第二行条件
            this.rData.trainingShifts = this.$fuwuData.banci[i2]
            if (i2 === 0) { delete this.rData.trainingShifts }
          }
          break;
        case 'rongzi': case 'zhaoshang': case 'jiameng':
          if (i === 0) {//第一行条件
            this.rData.status = this.$fuwuData.xiangmustatus[i2]
            if (i2 === 0) { delete this.rData.status }//选择 不限 时，删除此属性
          }
          //当下拉框选择‘不限’或者不选择时  就删除 ‘行业’ 属性  ,否则就赋值
          ((!this.fData.titleType) || this.fData.titleType=='不限')
            ? delete this.rData.belongToDomain
            : this.rData.belongToDomain = this.fData.titleType
          break;
        case 'touzi':
          if (i === 0) {//第一行条件
            this.rData.status = this.$fuwuData.touzitype[i2]
            if (i2 === 0) { delete this.rData.status }//选择 不限 时，删除此属性
          }
          //当下拉框选择‘不限’或者不选择时  就删除 ‘行业’ 属性  ,否则就赋值
          ((!this.fData.titleType) || this.fData.titleType=='不限')
            ? delete this.rData.belongToDomain
            : this.rData.belongToDomain = this.fData.titleType
          break;
        case 'zufang': case 'shoufang':
          if (i === 0) {//第一行条件
            this.rData.houseType = this.$fuwuData.housetype[i2]
            if (i2 === 0) { delete this.rData.houseType }//选择 不限 时，删除此属性
          } else if (i === 1) {//第二行条件
            this.rData.renovation = this.$fuwuData.housezhuangxiu[i2]
            if (i2 === 0) { delete this.rData.renovation }//选择 不限 时，删除此属性
          }
          break;
        case 'qiche':
          if (i === 0) {//第一行条件
            this.rData.carType = this.$fuwuData.cartype[i2]
            if (i2 === 0) { delete this.rData.carType }//选择 不限 时，删除此属性
          }
          break;
        case 'jiaoyou':
          if (i === 0) {//第一行条件
            this.rData.u_sex = this.$fuwuData.isSex[i2]
            if (i2 === 0) { delete this.rData.u_sex }//选择 不限 时，删除此属性
          } else if (i === 1) {//第二行条件
            this.rData.u_education = this.$fuwuData.education[i2]
            if (i2 === 0) { delete this.rData.u_education }//选择 不限 时，删除此属性
          }
          this.rData.openFriends = true
          break;
        case 'meishi':
          if (i === 0) {//第一行条件
            console.log(this.$fuwuData.foodtype[i2])
            this.rData.foodType = this.$fuwuData.foodtype[i2]
            if (i2 === 0) { delete this.rData.foodType }//选择 不限 时，删除此属性
          }
          if (i === 1) {//第二行条件
            this.rData.deliveryType = this.$fuwuData.getfoodtype[i2]
            if (i2 === 0) { delete this.rData.deliveryType }//选择 不限 时，删除此属性
          }
          break;
      }

      this.rData.pageNumber = this.paging_data.currentPage
      // console.log('发送请求的requesdata',this.rData,navAcHere)
      await this.$api.util_search(navAcHere, this.rData).then(res=> {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this[navAcHere + '_data'] = _R
          this.paging_data.total = res.data.size //获取该类数据的总数
          console.log(`%c返回的渲染数据:`, 'color: #f00;', this.tableData)
        } else { this._status(res.data) }
      })

      if (arguments.length === 0 || this.isGetScrollData) {//当进行条件查询时，不改变右边滚动的数据，不进行条件查询时才执行函数体
        this.getScrollData()
      }
    },

    getScrollData() {
      if (this.navAc === 'zhaopin') { // 招聘
        let data = {}
        data.areaId = this.pageAreaId_x || this.$route.query.areaId
        data.pageNumber = 1
        data.organization = true
        // this.$api.getqiuzhi(data).then(res => {
        this.$api.util_search('qiuzhi', data).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            console.log(`%c右侧滚动:`, 'color: #f00;', _R)
            this.scrollList = _R
          } else { this._status(res.data) }
        })
        
      } else if (this.navAc === 'lvshi' && this.lvshi_list[0].activeindex === 0) {
        this.scrollList = JSON.parse(JSON.stringify(this.zixun_data))
        // let rD = {
        //   pageNumber: 1,
        //   areaId: this.pageAreaId_x || this.$route.query.areaId,
        // }
        // this.$api.getflzx(rD).then(res => {
        //   if (res.data.status === 0) {
        //     let _R = JSON.parse(res.data.data)
        //     this.scrollList = _R
        //   } else { this._status(res.data) }
        // })
      } else {
        //点击服务名更换右边的滚动中的数据,且始终是前40条数据，不随页码的改变而改变。具体指的是路由进入页面page不为1，使该部分还是滚动第一页的数据
        let rD = {
          pageNumber: 1,
          areaId: this.pageAreaId_x || this.$route.query.areaId,
        }
        this.navAc === 'qiuzhi' ? rD.u_startGetJob = true : '' // 求职信息，查询用户列表，通过用户是否开启求职 查询
        this.navAc === 'jiaoyou' ? rD.openFriends = true : '' // 交友信息，查询用户列表，通过用户账号是否开启交友
        // console.log('右边滚动的请求',rD)
        this.$api.util_search(this.navAc, rD).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            // console.log(_R)
            this.scrollList = _R
          } else { this._status(res.data) }
        })
      }
    },

    //法律咨询子组件向父组件传值,获取法律咨询的数据总条数
    getDataSize(val) {
      this.paging_data.total = val
    },

  },
  created() {
    this.getDateWeek() // 获取日期和星期----显示在搜索框下面
  },
  mounted() {
    this.gunStart()
  },
  async beforeRouteEnter (to, from, next) {
    next(vm => {
      // console.log('id:',type)
      let { type, page, key, f } = to.query
      if (type) {
        vm.navAc = type
        vm.fData.fuwutype = type
        vm.paging_data.currentPage = page ? parseInt(page) : 1

        if (key) {
          console.log(key)
          vm.fData.keywords = key
          vm.searchHandler()
        } else if (f) {
          const arr = vm.lvshi_list[0].items
          const index = arr.indexOf(f)
          vm.lvshi_list[0].activeindex = index
          // vm.$set(vm.lvshi_list[0], 'activeindex', index)
          vm.isGetScrollData = true
          vm.getData(0, index)
        } else {
          vm.getData()
        }
      }
    })
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.timer)
  },
}
</script>

<style lang='scss' scoped>
/deep/ .searchbox input{font-size: 16px;width: 100%;height: 50px!important;line-height: 50px!important;border: none;}
.animate {transition: all 0.5s;}

/* 头部 */
.header{
  height: 130px;width: 100%;
  .header_top{
    background-color: #1E9FFF;color: #fff;
    .w1200{margin: 0px auto;height: 40px;line-height: 40px;}
    .topmain{
      line-height: 40px;height: 100%;
      a {color: #fff;cursor: pointer;margin-right: 15px;font-size: 14px;position: relative;}
      .fl i{margin-right: 5px;}
      .fl i :after{display: none;margin-right: 5px;}
      #App:hover .hide{display: block;}
      #chengxu:hover .hide{display: block;}
      #gongzhong:hover .hide{display: block;}
      #weibo:hover .hide{display: block;}
      #help:hover .hide{display: block;}
      a .hide{color: #303133;top: 39px;display: none;padding: 15px;left: -35px;position: absolute;width: 100px;line-height: 16px;border: 1px solid #1E9FFF;box-shadow: 0 5px 5px 5px rgba(0,0,0,0.1);text-align: center;background-color: #fff;}
      a .hide img{width: 100px;height: 100px;}
    }
  }
}
/* 头部顶部结束 */

.headermenu{
  padding: 20px 0px;width: 100%;
  .w1200{height: 50px;}
  .logo img{width: 50px;}
  .name{margin-left: 10px;}
  .name b{display: block;font-size: 26px;color: #1E9FFF;font-weight: bold;margin-top: -5px;}
  .name p{color: #666;font-size: 14px;}
  .location{font-size: 14px;text-align: center;margin-left: 20px;background-color: #fff;border: 1px solid #eee;border-radius: 3px;padding: 4px 10px;font-size: 14px;}
  .location i{width: 14px;height: 14px;float: left;margin: 2px 5px 0 0;}
  .menu{margin-top: 10px;}
  .menu li{float: left;font-size: 18px;padding-left: 15px;}
}

/* 搜索框 */
.search{
  background-color: #f3f3f3;padding: 40px 0 30px 0;margin-bottom: 20px;
  .w1200{
    width: 743px;height: 93px;
    .searchbox{
      width: 100%;height: 50px;margin-bottom: 30px;box-shadow: 0 0 10px rgba(0,0,0,0.05);background-color: #fff;
      input{font-size: 16px;width: 100%;height: 50px;line-height: 50px;border: none;}
      .searchbutton{width: 100%;height: 50px;font-size: 20px;border-radius: 0px;}
    }
    .welcome{font-size: 14px;color: #666;;text-align: center;}
  }
}
/* 搜索框结束 */

/* 服务 */
.fuwubox .selectfuwu{
  font-size: 14px;padding: 10px 0px;color: #666;border: 1px solid #eee;
  .titlebox{margin: 5px 5px;padding: 2px 5px;width: 100px;height: 30px;font-size: 14px ;color: #666 ;line-height: 30px;text-align: right;}
  .list{
    padding: 5px;
    span{
      cursor: pointer;display: inline-block;margin: 5px 5px;padding: 2px 5px;transition: all .2s;border: 1px solid rgba(0,0,0,0);
      &:hover,
      &.active{background-color: #fff3f3;color: #e30002;border-radius: 3px;border: 1px solid #e30002;}
    }
  }
}


.showData{
  margin-top: 30px;margin-bottom: 50px;justify-content: space-between;align-items:stretch;
  .left{width: 960px;}

  .right{
    position: -webkit-sticky;position: sticky;width: 210px;top: 0;
    .noCase{height: 550px;border: 1px solid #eee;margin-bottom: 20px;}
    .title{width: 195px;padding-left: 15px;height: 45px;line-height: 45px;color: #666;background-color: #f9f9f9;}

    /* 服务不是求职和招聘时，滚动盒子的样式 */
    .listbox{
      overflow: hidden;height: 470px;padding: 10px 15px;
      li:hover{
        cursor: pointer;
        .comname{color: #1E9FFF!important;}
      }
      .list{
        width: 180px;position: relative;top: 0px;
        li{
          font-size: 14px;color: #444444;line-height: 30px;height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
          &:hover{cursor: pointer;color: #1E9FFF;}
        }
      }
    }

    /* 服务为招聘时，滚动盒子的样式 */
    .listboxa{
      overflow: hidden;height: 470px;
      li:hover{
        cursor: pointer;
        .comname{color: #1E9FFF!important;}
      }
      .list{
        position: relative;top: 0px;width: 100%;
        li{
          width: 100%;padding-top: 20px;font-size: 14px;color: #444444;height: 180px;border-bottom: 1px solid #eee;
          .imgbox{
            width: 80px;height: 80px;margin: 0px auto;
            img{width: 100%;height: 100%;}
          }
          .comname{text-align: center;color: #444444;padding: 10px 0px;font-size: 16px;}
          .info{
            border-top: 1px solid #eee;width: 100%;display: flex;justify-content: space-around;
            span{
              display: inline-block;width: 50%;padding:5px 0px;line-height: 24px;text-align: center;
              &:nth-child(1){border-right: 1px solid #eee;}
              .number{color: #8097ba;}
            }
          }
        }
      }
    }

    /* 服务为求职时，滚动盒子的样式 */
    .listboxb{
      overflow: hidden;height: 470px;padding: 0px 15px;
      li:hover{
        cursor: pointer;
        .comname{color: #1E9FFF!important;}
      }
      .list{
        position: relative;top: 0px;width: 180px;
        li{padding-top: 10px;font-size: 14px;color: #444444;height: 200px;border-bottom: 1px solid #eee;}
        .imgbox{
          width: 80px;height: 80px;margin: 0px auto;
          img{width: 100%;height: 100%;}
        }
        p{
          font-size: 16px;text-align: center;
          &.peoplename{height: 40px;line-height: 40px;color: #666;}
          &.workname{height: 25px;line-height: 25px;color: #1e9fff;}
          &.money{height: 30px;line-height: 30px;color: #ff6766;}
        }
      }
    }

    /* 服务为律师时，且滚动中的数据为律师信息时，滚动盒子的样式 */
    .lvshibox{
      overflow: hidden;height: 470px;padding: 0px 15px;
      li:hover{
        cursor: pointer;
        .comname{color: #1E9FFF!important;}
      }
      .list{
        position: relative;top: 0px;width: 180px;
        li{
          text-align: center;height: 138px;padding: 10px 0px;border-bottom: 1px solid #eee;
          &:hover{
            cursor: pointer;
            .name{color: #1E9FFF;}
          }
          .imgbox img{width: 78px;height: 78px;}
          p{height: 25px;line-height: 25px;font-size: 14px;}
        }
      }
    }
  }
}




.c1E9FFF{color: #1E9FFF !important;font-weight: 400;font-size: 18px !important;}
/* 星星 */
.el-icon-star-on{font-size: 30px;}
.star .el-rate__text{display: inline-block;margin-left: 10px;font-size: 20px;}
</style>